/* モーダル */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
var ModalTemplate = function (_a) {
    var show = _a.show, title = _a.title, body = _a.body, ClickCallBackYes = _a.ClickCallBackYes, ClickCallBackNo = _a.ClickCallBackNo, t = _a.t;
    return (React.createElement(Modal, { size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, { className: "dialog-title" }, title)),
        React.createElement(Modal.Body, { className: "dialog-body" }, body),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackYes }, t('はい')),
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackNo }, t('いいえ')))));
};
export default ModalTemplate;
